export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10492.776b3e77.jpg";